import { useConfig, withSafeNext } from '../auth'
import { redirectToProvider, Client, settings } from '../lib/allauth'
import GoogleOneTap from './GoogleOneTap'
import { Button, Space } from 'antd'

export default function ProviderList (props) {
  const config = useConfig()
  const providers = config.data.socialaccount.providers
  if (!providers.length) {
    return null
  }
  return (
    <>
      <GoogleOneTap process={props.process} />
      {settings.client === Client.BROWSER && (
        <Space direction='vertical' style={{ width: '100%' }}>
          {providers.map(provider => {
            return (
              <Button key={provider.id} block onClick={() => redirectToProvider(provider.id, withSafeNext(props.callbackURL, window.location.search), props.process)}>{provider.name}</Button>
            )
          })}
        </Space>
      )}
    </>
  )
}
